<app-header></app-header>
<main id="content">
  <section id="exercise-page">
    <div [ngStyle]="{'background': '#464646 url(' + eachExerciseObj.image + ')'}" class="hero hero-exercise"></div>
    <div class="container header">
      <div class="row flex-row end">
        <div class="col-md-12">
          <span class="label label-success mobile-label-show" *ngIf="eachExerciseObj.status.status == 'completed'">you've already done this</span>
          <ul class="breadcrumbs inline-block">
            <li>
              <a href="/#/paths/{{eachExerciseObj.path_id}} " class="link">{{eachExerciseObj.path_name}}</a>
            </li>
          </ul>
          <div class="group">
            <h1 class="heading-lg">{{eachExerciseObj.name}}</h1>
            <span class="label label-success desktop-label-show" *ngIf="eachExerciseObj.status.status == 'completed'">you've already done this</span>
            <span class="label" *ngIf="eachExerciseObj.status.status == 'active' && eachExerciseObj.path_status !='abandoned'">your next exercise</span>
          </div>
          <div class="group exercise-player" *ngIf="(eachExerciseObj.status.status == 'completed') || (eachExerciseObj.status.status == 'locked' && eachExerciseObj.path_status == 'abandoned') || (eachExerciseObj.status.status == undefined) || (eachExerciseObj.status.status == 'active')">
            <a [ngClass]="{'btn-disabled':eachExerciseObj.path_status=='abandoned' ||eachExerciseObj.status.status == undefined }" href="/#/exercise/{{eachExerciseObj.id}}/ongoing"
              role="button" data-action="launchExercise" class="btn btn-lg btn-primary btn-inline text-uppercase">
              <i class="fa fa-play T12"></i>
              <span *ngIf="eachExerciseObj.status.status == 'completed'">click to do exercise once again</span>
              <span [ngClass]="{'btn-disabled':eachExerciseObj.status.status==undefined}" *ngIf="eachExerciseObj.status.status == 'active' || eachExerciseObj.status.status == 'locked' || eachExerciseObj.status.status == undefined">click to start exercise</span>
            </a>
            <div class="group locked-text desktop-show" *ngIf="eachExerciseObj.path_status=='abandoned' || eachExerciseObj.status.status == undefined">
              <i class="fa fa-lock D3"></i>
              <span class="text text-sm">
                This exercise is part of path that is not assingned to
                <br>you and you can not do this exercise </span>
            </div>
            <div class="status-box flex-row middle center mobile-show" *ngIf="eachExerciseObj.path_status=='abandoned' || eachExerciseObj.status.status == undefined">
              <div class="block text-center">
                <i class="fa fa-lock"></i>
                <p class="text text-md">
                    This exercise is part of path that is not assingned to you and you can not do this exercise
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid exercise-bar">
      <div class="row">
        <div class="col-md-12">
          <div class="container">
            <div class="row flex-row middle">
              <div class="col-md-12 full-width-mobile">
                <ul class="exercise-progress-bar" #progressBar>
                  <!-- Li element will be appended form ts file. -->
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid body">
      <div class="row">
        <div class="col-md-12">
          <div class="container">
            <div class="row">
              <div class="col-md-6 markdown-content">
                <p>
                  <strong>{{eachExerciseObj.name}}</strong>
                </p>
              </div>
              <div class="col-md-6" *ngIf="eachExerciseObj['teaching_points']">
                <h2 class="heading-md">Teaching Points</h2>
                <ul class="bulleted-list-2" *ngFor="let teaching of eachExerciseObj['teaching_points']">
                  <li [attr.data-teaching-point-id]="teaching.id">
                    <span class="text text-lg">{{teaching.text}}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
<app-dailyquotes></app-dailyquotes>
<app-footer></app-footer>
<app-menu></app-menu>


// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/each-exercise/each-exercise.component.html